export interface IMenuSet {
  identifier: string;
  item_keys: any;
  options: any;
  possible_count_of_order: string;
  button_name: string;
  button_name_en: string;
  button_name_cn: string;
  button_name_kr: string;
  fix_parent_count: boolean;
}
export class MenuSetDTO implements IMenuSet {
  identifier: string;
  item_keys: any;
  options: any;
  possible_count_of_order: string;
  button_name: string;
  button_name_en: string;
  button_name_cn: string;
  button_name_kr: string;
  fix_parent_count: boolean;
}

export default class MenuSet extends MenuSetDTO {
  constructor(dto?: MenuSetDTO) {
    super();
    if (dto) {
      Object.assign(this, dto);
    } else {
      this.new();
    }
  }

  public new() {
    Object.assign(this, {
      identifier: "",
      item_keys: "",
      options: [],
      possible_count_of_order: "",
      button_name: "",
      button_name_en: "",
      button_name_cn: "",
      button_name_kr: "",
      fix_parent_count: "",
    });
  }
}
